export default __webpack_public_path__ + "static/Mercedes-1bbe58fbefd4f93a02831f9de3a30cbf.jpg";